import { render, staticRenderFns } from "./TourTooltip.vue?vue&type=template&id=6a0127d2&scoped=true"
import script from "./TourTooltip.vue?vue&type=script&lang=js"
export * from "./TourTooltip.vue?vue&type=script&lang=js"
import style0 from "./TourTooltip.vue?vue&type=style&index=0&id=6a0127d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0127d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0127d2')) {
      api.createRecord('6a0127d2', component.options)
    } else {
      api.reload('6a0127d2', component.options)
    }
    module.hot.accept("./TourTooltip.vue?vue&type=template&id=6a0127d2&scoped=true", function () {
      api.rerender('6a0127d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tours/TourTooltip.vue"
export default component.exports